import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaComponent } from './fa.component';

/**
 * Drop-in replacement for the abandoned `angular-font-awesome` package.
 * Import `AngularFontAwesomeModule` exactly as before — no template changes needed.
 */
@NgModule({
  declarations: [FaComponent],
  imports: [CommonModule],
  exports: [FaComponent],
})
export class AngularFontAwesomeModule {}
